// extracted by mini-css-extract-plugin
export default {"overlay-contain":"styles_overlay-contain__f3Gwn","main":"styles_main__QL+RH"};